import { call, put, select } from 'redux-saga/effects';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { bulkFilesClosed } from 'features/content-library/actions';
import {
  selectContentLibraryActiveFiles,
  selectPreviewedFile,
} from 'features/content-library/contentLibrarySlice';
import { gridPanelTabClosed } from 'features/layout/features/content/contentSlice';
import { clearLockedContentSaga } from 'features/layout/features/content/sagas/clearLockedContentSaga';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* bulkFilesClosedSaga(ids: string[]) {
  yield put(bulkFilesClosed(ids));

  yield call(clearLockedContentSaga, { type: 'file', ids });

  const files: ContentLibraryOpenedFile[] = yield select(selectContentLibraryActiveFiles);

  if (files.length === 0) {
    const previewedFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);

    if (!previewedFile && contentBoard.id && contentBoard.type === 'file') {
      yield call(contentBoard.reset);
    }

    yield put(gridPanelTabClosed('contentLibrary'));
  }
}
